export default "__VITE_ASSET__oC11rxlf__"